import React from 'react'

export const CreateAssignLead = () => {
  return (
    <div>create1</div>
  )
}
